import axios from 'src/api/Api';
import {
    VIEW_REPORT_SUCCESS,
    VIEW_REPORT_FAILURE,
    VIEW_REPORT_HISTORY,
} from 'src/pages/orders/redux/actions';
import { put } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { convertObjectToQueryParams } from 'src/utils/util';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export default function* viewReport(action) {
    const url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/reports/usageReports?`;

    const params = convertObjectToQueryParams(
        {
            myCASERef: action.payload.myCaseRef,
            pricing: action.payload.pricing,
            reportOption: action.payload.reportOption,
            isEmail: action.payload.isEmail,
        },
        true
    );

    let finalUrl = url + `${params}`;

    try {
        const result = yield axios
            .get(finalUrl)
            .then((response) => response.data);
        yield put({ type: VIEW_REPORT_SUCCESS, payload: result });

        yield put({
            type: VIEW_REPORT_HISTORY,
            payload: {
                reportHistory:
                    result?.reportHistory && result.reportHistory.length > 0
                        ? result.reportHistory
                        : [],
            },
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: finalUrl,
            requestPayload: action.payload
        });
        yield put({
            type: VIEW_REPORT_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
